export default {
    //档案树形节点新增接口
    addAuditNode(params, response) {
        window.vue.$apiAxios.postRequestBody('/auditGroupManage/addAuditNode', params, response);
    },
    //档案树形编辑接口
    updateAuditNode(params, response) {
        window.vue.$apiAxios.postRequestBody('/auditGroupManage/updateAuditNode', params, response);
    },
    //档案树形删除接口
    deleteAuditNode(params, response) {
        window.vue.$apiAxios.postRequestBody('/auditGroupManage/deleteAuditNode', params, response);
    },
    //档案信息查询接口
    queryAuditInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('auditManage/queryAuditInfo', params, response);
    },
    //档案类目table展示信息查询接口
    queryFileListTable(params, response) {
        window.vue.$apiAxios.postRequestBody('/auditGroupManage/queryAuditTree', params, response);
    },
    //档案信息查询接口
    queryFileInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auditManage/queryAuditList', params, response);
    },
    //档案信息新增接口
    addFileInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auditManage/addBatchAudit', params, response);
    },
    //档案信息修改接口
    updateFileInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auditManage/updateAudit', params, response);
    },
    //档案信息批量删除接口
    deleteBatchFileInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auditManage/deleteBatchAudit', params, response);
    },
    //根据扩展组ids查询扩展组信息和元素的接口
    searchLabelGroupByIds(params, response) {
        window.vue.$apiAxios.postRequestBody('/workFlowLabelGroup/queryLabelGroup', params, response);
    },
    //分页查询用户信息接口
    queryUserInfoByPage(params, response) {
        window.vue.$apiAxios.postRequestBody('/customAudit/queryUserInfoByPage', params, response);
    },
    //查询档案关联用户信息接口
    queryAuditRelateUserInfo(params, response) {
        window.vue.$apiAxios.postRequestBody('/auditManage/queryAuditRelateUserInfo', params, response);
    },
    //模板下载接口
    templateUpload(params, responseType, response) {
        window.vue.$apiAxios.downloadPost('/auditManage/importAuditTemplate', params, responseType, response);
    },
    //档案信息导入接口
    importAudit(params, response) {
        window.vue.$apiAxios.postRequestBody('/auditManage/importAudit', params, response);
    },
    //档案信息导出接口
    exportAudit(params, responseType, response) {
        window.vue.$apiAxios.downloadPost('/auditManage/exportAudit', params, responseType, response);
    }
};
